let _accessToken = null;
let _tokenType = 'bearer';

export function getAccessToken() {
  return _accessToken;
}

export function getTokenType() {
  return _tokenType;
}

export function setTokens(accessToken, tokenType) {
  _accessToken = accessToken;
  _tokenType = tokenType || 'bearer';
}

export function clearTokens() {
  _accessToken = null;
  _tokenType = 'bearer';
}
